import React, { useState, useEffect } from 'react';
import { AppHeader } from '@/components/AppHeader';
import { useNavigationHistory } from '@/hooks/useNavigationHistory';
import { supabase } from '@/integrations/supabase/client';
import { User } from '@supabase/supabase-js';
import MyScoresDashboard from '@/components/dashboard/MyScoresDashboard';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { TrendingUp } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function MyScoresPage() {
  const [user, setUser] = useState<User | null>(null);
  useNavigationHistory();

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setUser(session?.user ?? null);
    });
    
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleSignOut = async () => {
    await supabase.auth.signOut();
  };

  return (
    <div className="min-h-screen bg-background">
      <AppHeader user={user} onSignOut={handleSignOut} />

      <div className="container mx-auto p-4 max-w-4xl space-y-6">
        {/* Correlation Explorer Quick Link */}
        <Card className="border-2 border-accent/50 bg-accent/5">
          <CardHeader className="pb-3">
            <div className="flex items-center gap-2">
              <TrendingUp className="h-5 w-5 text-primary" />
              <CardTitle className="text-lg">Want to understand what's affecting your scores?</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground mb-4">
              Use the Correlation Explorer to discover how your lifestyle choices impact these scores. See which factors have the strongest influence on your health.
            </p>
            <Link to="/vault?tab=correlations">
              <Button variant="outline" size="sm">
                <TrendingUp className="h-4 w-4 mr-2" />
                Explore Correlations
              </Button>
            </Link>
          </CardContent>
        </Card>

        <MyScoresDashboard />
      </div>
    </div>
  );
}
